import styled from 'styled-components'
import { Spacing, Inset } from '@doordash/design-language'

export const Container = styled.div`
  padding-left: ${Spacing.Small}px;
  padding-right: ${Spacing.Small}px;
`
export const Bottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;
`
export const ClearPadding = styled.div`
  padding: 0;
`

export const ImageContainer = styled.div`
  svg {
    width: 100%;
  }
`
export const TitleContainer = styled(Inset)`
  padding-top: 0;
`
